<template>
	<div id="app" style="height: 100%;">
		<router-view style="height: 100%;" />
		<modal-view />
		<div v-if="$store.state.image" class="image-view" @click="$store.commit('image', null)">
			<div class="image" :style="{ backgroundImage: `url(${$store.state.image})` }"></div>
		</div>
		<popup-view />
		<FileOverlay />
		<CameraOverlay :active="$store.state.cameraActive" @captured="captured" @closed="closed" />
	</div>
</template>

<script>
	export default {
		name: 'app',
		mounted() {
			const self = this;

			setTimeout(() => {
				self.$store.dispatch('updateNews');
			}, 1000);
		},
		methods: {
			async captured(blob) {
				console.log('Captured blob:', blob);
				console.log(this.$store.getters.cameraUrl);


				const formData = new FormData()
				formData.append('file', blob, 'capture.jpg')

				try {
					const { data } = await this.axios.post(
						this.$store.getters.cameraUrl,
						formData,
						{
							headers: { 'Content-Type': 'multipart/form-data' }
						}
					)
					console.log('Upload result:', data)
				} catch (err) {
					console.error('Upload failed:', err)
				}


				//this.$store.commit('cameraActive', false);
				//this.$store.commit('image', URL.createObjectURL(blob));
			},
			closed() {
				this.$store.commit('cameraActive', false);
			}
		}
	}
</script>

<style>
	#app {
		height: 100%;
	}

	* {
		font-family: Montserrat, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-size: 14px;
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	html, body {
		height: 100%;
	}

	.image-view {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.8);
	}

	.image-view > .image {
		position: absolute;
		left: 5%;
		top: 5%;
		width: 90%;
		height: 90%;
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
	}
</style>
